<template lang="pug">
    .settings-store
        settings-page-head
        .settings-account-management-wrapper.mt-46
            .account-management__wrapper-section
                head-of-settings-section(:title="headerTitle")
                .settings__form-wrapper
                    .left-form-section
                        settings-form-input(title="Product Name" type="text" :max="30" v-model="form.title" :error="getErrorMessage('title')")
                        settings-form-input(title="Price" type="number" :max="999999" :min="0.01" :step="0.01" required v-model="form.price" :mt="true" :error="getErrorMessage('price')")
                    .right-form-section
                        .re-inp-box.textarea-wrap
                            re-textarea.two-lines-plus(
                                name="description"
                                label="Description"
                                placeholder="Description"
                                v-model="form.description"
                            )
                            span.settings-input-error {{ getErrorMessage('description') }}

                .settings-form-upload-media.settings-input-wrapper-mt
                    span.settings-input-block-name Upload Media
                    creator-image-upload-control(v-model='images' ref='uploadControl')
                    span.settings-input-error {{ getErrorMessage('images') }}

                .settings-form-actions
                    settings-form-button(v-if='editing' title='Cancel' @click.native='clearForm')
                    settings-form-button(:title='buttonLabel' @click.native='saveOrCreate')

            .account-management__wrapper-section(v-scroll-bottom="scrollBottom")
                head-of-settings-section(title="Products")
                .store-page-product-list
                    .store-page-product-list__item(v-for='(product, key) in products' :key='key')
                        .product-list-item__image
                            img(:src='getFirstImageUrl(product)' alt='')
                        .product-list-item__description
                            .product-list-item-info
                                .product-list-item-info__title {{ product.title }}
                                .product-list-item-info__price ${{ product.price }}
                        .product-list-item__actions(@click.stop="openActions(product.id)")
                            svg-icon(iconId="menu-dots")
                            .actions(v-if="showActions === product.id")
                                .action(@click='viewProduct(product)') View
                                .action(@click='editProduct(product)') Edit
                                .action(@click='deleteProduct(product)') Delete
</template>

<script>
import settingsStoreService from '../services/settings-store-service'
import { mapGetters } from 'vuex';

export default {
    name: "settings-store-page",
    data() {
        return {
            form: {
                title: '',
                price: 0.01,
                description: '',
            },
            pagination: {
                currentPage: 0,
                lastPage: 1,
                total: 0,
            },
            showActions: null,
            images: [],
            products: [],
            editing: null,
            errors: [],
            loaded: false,
        }
    },
    computed: {
        ...mapGetters(['authUser']),
        headerTitle() {
            return this.editing ? `Edit product #${this.editing.id}` : 'Add New Product'
        },
        buttonLabel() {
            return this.editing ? 'Save' : 'Add to store'
        },
        isLastPage() {
            return this.pagination.currentPage === this.pagination.lastPage
        },
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            if (this.loaded && this.isLastPage) {
                return
            }

            let params = []

            params.push(`page=${this.pagination.currentPage + 1}&where=${encodeURIComponent(JSON.stringify({
                type: 'creator',
                is_active: 1,
            }))}&order=id:desc`)

            settingsStoreService.get(params).then(({data}) => {
                if (this.loaded) {
                    this.products.push(...data.data)
                } else {
                    this.products = data.data
                    this.loaded = true
                }

                this.pagination.currentPage = data.meta.pagination.current_page
                this.pagination.lastPage = data.meta.pagination.total_pages
                this.pagination.total = data.meta.pagination.total
            })
        },
        createProduct() {
            let formData = {...this.form}
            formData.type = 'creator'
            formData.images = this.images.map(i => i.id)

            settingsStoreService.store(formData)
                .then(({data}) => {
                    this.products.unshift(data.data)
                    this.clearForm()
                    this.scrollToProducts()
                })
                .catch(error => {
                    if (typeof error.response.data === 'object') {
                        this.errors = error.response.data.errors
                    }
                });
        },
        editProduct(product) {
            this.editing = product
            this.form.title = product.title
            this.form.price = product.price
            this.form.description = product.description
            this.$refs.uploadControl.setFiles(product.images.data)

            this.$parent.$parent.$refs.scroll.scrollElement.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        },
        updateProduct() {
            let formData = {...this.form}
            formData.type = 'creator'
            formData.images = this.images.map(i => i.id)

            settingsStoreService.save(this.editing.id, formData)
                .then(({data}) => {
                    const currentProductIndex = this.products.findIndex(item => this.editing.id === item.id)
                    this.products[currentProductIndex] = data.data
                    this.clearForm()
                    this.scrollToProducts()
                })
                .catch(error => {
                    if (typeof error.response.data === 'object') {
                        this.errors = error.response.data.errors
                    }
                });
        },
        deleteProduct(product) {
            settingsStoreService.delete(product.id).then(() => {
                const currentProductIndex = this.products.findIndex(item => product.id === item.id)
                this.products.splice(currentProductIndex, 1)
            })
        },
        viewProduct(product) {
            this.$router.push({ name: 'store-product-page', params: { username: this.authUser.username, productId: product.id }})
        },
        saveOrCreate() {
            if (this.editing) {
                this.updateProduct()
            } else {
                this.createProduct()
            }
        },
        scrollToProducts() {
            const scrollEl = this.$parent.$parent.$refs.scroll.scrollElement
            scrollEl.scrollTo({
                top: 850,
                behavior: 'smooth'
            })
        },
        scrollBottom() {
            this.fetch()
        },
        clearForm() {
            this.form.title = ''
            this.form.price = ''
            this.form.description = ''
            this.editing = null
            this.errors = []
            this.$refs.uploadControl.setFiles([])
        },
        getFirstImageUrl(product) {
            return product.images.data.length ? product.images.data[0].url : null
        },
        getErrorMessage(name) {
            return this.errors && this.errors[name] ? this.errors[name][0] : ''
        },
        openActions(id) {
            this.showActions = this.showActions === id ? null : id
        },
    },
}
</script>
